import * as Types from '../../../../../../../generated/base-types';

import { gql } from 'apollo-angular';
import { ExamDetailsFragmentDoc } from './load-exam.generated';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type UpdateExamMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
  attributes: Types.ExamInput;
}>;


export type UpdateExamMutation = { __typename?: 'Mutation', updateExam?: { __typename?: 'UpdateExamPayload', successful: boolean, exam?: { __typename?: 'Exam', id: string, name: string, date: string, duration?: number | null, medium?: string | null, typ?: string | null, has_scrambling_b?: boolean | null, number_of_additional_scramblings?: number | null, locked_at_date?: string | null, de: boolean, en: boolean, fr: boolean, it: boolean, show_first_dimension_presort?: boolean | null, allow_question_comments?: boolean | null, first_presort_criterion?: boolean | null, second_presort_criterion?: boolean | null, third_presort_criterion?: boolean | null, locked: boolean, self_assessed: boolean, is_in_the_future: boolean, provisioned: boolean, examinator_unlock_token?: string | null, content: { __typename?: 'TranslatedContent', de?: string | null, en?: string | null, fr?: string | null, it?: string | null }, presort_criteria: Array<{ __typename?: 'PresortCriteria', type?: string | null, name?: string | null, position?: number | null }> } | null, validations?: { __typename?: 'ValidationsExamFieldMessages', fieldMessages?: Array<{ __typename?: 'FieldMessage', field: string, messages: Array<{ __typename?: 'ValidationsMessage', message: string }> }> | null } | null } | null };

export const UpdateExamDocument = gql`
    mutation UpdateExam($id: ID!, $attributes: ExamInput!) {
  updateExam(id: $id, attributes: $attributes) {
    exam {
      ...ExamDetails
    }
    successful
    validations {
      fieldMessages {
        field
        messages {
          message
        }
      }
    }
  }
}
    ${ExamDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateExamGQL extends Apollo.Mutation<UpdateExamMutation, UpdateExamMutationVariables> {
    document = UpdateExamDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }